import { render, staticRenderFns } from "./topSearch.vue?vue&type=template&id=81fc4308&scoped=true&"
import script from "./topSearch.vue?vue&type=script&lang=js&"
export * from "./topSearch.vue?vue&type=script&lang=js&"
import style0 from "./topSearch.vue?vue&type=style&index=0&id=81fc4308&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fc4308",
  null
  
)

export default component.exports